import { EstablishmentReportType } from "../interfaces/establishment";

export const REPORT_LABELS: Record<EstablishmentReportType, string> = {
    wrong_data: "Données incorrectes",
    not_relevant: "Non pertinent",
    duplicate: "Doublon",
    closed: "Fermé / obsolète",
    not_interested: "Pas intéressé",
    naf_mismatch: "Code NAF hors scope",
    unpaid: "Impayés",
    payment_delay: "Retard de paiement",
};

// Reasons about how the prospect pays rather than about the quality of the data. Shown as
// their own section in the report popup, and the row's tooltip lists them first: "he never
// pays" and "he pays late" are two different conversations, and both are worth reading
// before the call.
export const PAYMENT_REPORT_TYPES: EstablishmentReportType[] = ['unpaid', 'payment_delay'];

export const REPORT_COLORS: Record<EstablishmentReportType, string> = {
    wrong_data: "text-orange-600 bg-orange-50 border-orange-200",
    not_relevant: "text-gray-500 bg-gray-50 border-gray-200",
    duplicate: "text-yellow-700 bg-yellow-50 border-yellow-200",
    closed: "text-red-600 bg-red-50 border-red-200",
    not_interested: "text-purple-600 bg-purple-50 border-purple-200",
    naf_mismatch: "text-blue-600 bg-blue-50 border-blue-200",
    unpaid: "text-red-700 bg-red-50 border-red-200",
    payment_delay: "text-orange-700 bg-orange-50 border-orange-200",
};

// Tailwind text-only color (no bg/border) for inline use
export const REPORT_TEXT_COLORS: Record<EstablishmentReportType, string> = {
    wrong_data: "text-orange-600",
    not_relevant: "text-gray-500",
    duplicate: "text-yellow-600",
    closed: "text-red-600",
    not_interested: "text-purple-600",
    naf_mismatch: "text-blue-600",
    unpaid: "text-red-700",
    payment_delay: "text-orange-700",
};
